import React, { useEffect, useState } from "react";
import { action, API, controller } from "../../../../api/api";
import { Button } from "../../../../controls";

const PaymentType = ({ handleAddPayment }) => {
  const [payMethods, setPayMethods] = useState([]);

  useEffect(() => {
    API(controller.PayType + action.GetAllByOrg).get((res) => {
      setPayMethods([...res.result]);
    });

    return () => {};
  }, []);

  return (
    <>
      <div className="grid grid-cols-3 gap-3 md:gap-4 p-3 md:p-5">
        {payMethods.map((method, index) => (
          <Button
            key={index}
            onClick={() => handleAddPayment(method)}
            className="w-full !font-normal md:!font-medium !text-lg md:!text-xl !uppercase !p-2 md:!p-3 transition-colors"
          >
            {method.name}
          </Button>
        ))}
      </div>
    </>
  );
};

export default PaymentType;
